import { Card, Button, completedFilter, DepositStatus, type SwapStatus } from '@valiant/ui-shared'
import { maskSwapStatus } from '../../utils/swapStatus'
import { useNavigation } from '../../contexts/NavigationContext'
import { Eye } from 'lucide-react'
import { useGetTransactionsQuery } from '../../generated/graphql'
import { useNavigate } from 'react-router-dom'
import { CompletedTransactionItem } from './shared/CompletedTransactionItem'

import { useInterval } from '@valiant/ui-shared'

export function RecentActivity() {
  const { selectedCompanyId } = useNavigation()
  const navigate = useNavigate()

  // Fetch recent transactions (limited to first 5, filter for APPROVED ones in component)
  const [{ data: transactionsData, fetching: transactionsLoading }, refetchTransactions] =
    useGetTransactionsQuery({
      variables: {
        filter: {
          companyId: selectedCompanyId || '',
        },
      },
      pause: !selectedCompanyId,
      requestPolicy: 'network-only',
    })

  useInterval(() => {
    if (selectedCompanyId) {
      refetchTransactions({ requestPolicy: 'network-only' })
    }
  }, 10000)

  // Filter and limit recent activity to first 5 approved transactions
  const recentActivity = (transactionsData?.getTransactions.nodes || [])
    .filter((transaction) => {
      if (transaction.type === 'DEPOSIT' && transaction.depositStatus === DepositStatus.Rejected) {
        return false
      }

      return completedFilter.includes(
        (transaction.depositStatus as DepositStatus) ||
          (maskSwapStatus(transaction.swapStatus, transaction.isExternalApi) as SwapStatus),
      )
    })
    .slice(0, 5)

  return (
    <div className="pb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-gray-900">Recent Activity</h2>
        <Button
          variant="main_action"
          size="sm"
          onClick={() => navigate(`/companies/${selectedCompanyId}/activity`)}
          className="h-[39px]"
        >
          <Eye className="h-6 w-6" />
          View More
        </Button>
      </div>

      {transactionsLoading && transactionsData === undefined ? (
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <Card key={i} className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-20 h-6 bg-gray-200 rounded-full animate-pulse"></div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
                    <div className="space-y-1">
                      <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
                      <div className="h-3 w-12 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-16 h-6 bg-gray-200 rounded-full animate-pulse"></div>
                  <div className="w-20 h-4 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      ) : recentActivity.length ? (
        <div className="flex flex-col gap-3">
          {recentActivity.map((activity) => (
            <CompletedTransactionItem key={activity.id} transaction={activity} />
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-500">No recent completed activity found for this company.</p>
        </div>
      )}
    </div>
  )
}
